<template>
  <div class="collapse-wrapper">
    <transition name="collapse">
      <div v-if="isVisible" class="collapse-content" :id="id">
        <div class="collapse-inner">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PostCollapse',
  props: {
    id: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: this.visible
    };
  },
  watch: {
    visible(newVal) {
      this.isVisible = newVal;
    }
  },
  mounted() {
    if (!window.collapseElements) {
      window.collapseElements = {};
    }
    window.collapseElements[this.id] = this;
  },
  beforeUnmount() {
    if (window.collapseElements && window.collapseElements[this.id]) {
      delete window.collapseElements[this.id];
    }
  },
  methods: {
    toggle() {
      this.isVisible = !this.isVisible;
    },
    show() {
      this.isVisible = true;
    },
    hide() {
      this.isVisible = false;
    }
  }
};
</script>

<style scoped>
  .collapse-wrapper {
    display: block;
  }

  .collapse-content {
    overflow: hidden;
  }

  .collapse-inner {
    display: block;
  }
</style>

<style>
  /* Vue 3 transition classes */
  .collapse-enter-from,
  .collapse-leave-to {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
  }

  .collapse-enter-active,
  .collapse-leave-active {
    transition: max-height 0.35s ease, opacity 0.35s ease;
    overflow: hidden;
  }

  .collapse-enter-to,
  .collapse-leave-from {
    max-height: 1000px;
    opacity: 1;
  }

  /* Vue 2 transition classes */
  .collapse-enter,
  .collapse-leave-to {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
  }

  .collapse-enter-to,
  .collapse-leave {
    max-height: 1000px;
    opacity: 1;
  }
</style>